import { Box, CircularProgress } from '@ltvco/refresh-lib/theme';
import { useFeatureIsOn, useGrowthBook } from '@ltvco/refresh-lib/vendors';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AccountPageV2 } from 'components/ChatBV/components/AccountPage/AccountPageV2';
import { MonitoredReportsPage } from 'components/ChatBV/components/ReportLibrary/MonitoredReports/MonitoredReportsPage';
import { ReportLibraryLandingPage } from 'components/ChatBV/components/ReportLibrary/ReportLibraryLandingPage';
import { UpgradePlanPage } from 'components/ChatBV/components/UpgradePlanPage';
import { ChatLayoutProvider } from 'components/ChatBV/context';
import { NotFound } from 'routes';

import { DeepSearchLayoutProvider, DeepSearchProvider } from '../context';

import { DeepSearchLayout } from './DeepSearchLayout';
import { DeepSearchPage } from './DeepSearchPage';
import { LoadingContainer } from './DeepSearchPage.styles';

const DEEPSEARCH_BASE_PATH = '/deepsearch/chat';

function ReportLibraryLandingRoute() {
  const { pathname } = useLocation();
  return (
    <ReportLibraryLandingPage key={pathname} basePath={DEEPSEARCH_BASE_PATH} />
  );
}

interface DeepSearchContainerProps {
  onLogout: () => void;
}

export const DeepSearchContainer = ({ onLogout }: DeepSearchContainerProps) => {
  const gb = useGrowthBook();
  const isInDeepSearchVariation = useFeatureIsOn('prop-3834');

  if (!gb?.ready) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  if (!isInDeepSearchVariation) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box sx={{ height: '100dvh', width: '100%' }}>
      <DeepSearchProvider>
        <ChatLayoutProvider>
          <DeepSearchLayoutProvider>
            <Routes>
              <Route
                path="/*"
                element={<DeepSearchLayout onLogout={onLogout} />}
              >
                <Route
                  index
                  element={<Navigate to="/deepsearch/chat" replace />}
                />
                <Route path="chat" element={<DeepSearchPage />} />
                <Route
                  path="chat/conversation/:contextId?"
                  element={<DeepSearchPage />}
                />
                <Route
                  path="chat/library"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="chat/library/monitored"
                  element={<MonitoredReportsPage />}
                />
                <Route
                  path="chat/library/list/:listCode"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="chat/library/:breadcrumbTitle"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="account"
                  element={
                    <AccountPageV2 upgradePath="/deepsearch/upgrade/plan" />
                  }
                />
                <Route path="upgrade/plan" element={<UpgradePlanPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </DeepSearchLayoutProvider>
        </ChatLayoutProvider>
      </DeepSearchProvider>
    </Box>
  );
};
